// extracted by mini-css-extract-plugin
module.exports = {"collapse":"collapse___1h7ke","isOpened":"isOpened___1SXt9","collapse-title":"collapse-title___1cZkf","icon":"icon___22qMl"};